// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"a7e85fbd","340":"63432cbb","748":"cfb2a451","774":"e3bd9f74","787":"142f6dcb","854":"a3c938b7"}[chunkId] + ".chunk.js";
};